import React, { useState } from "react";
import AdminHeader from "../../../../components/AdminHeader";
import AdminPageHeader from "../../../../components/admin/AdminPageHeader";

export default function EditorialBuilder() {

  const [blocks, setBlocks] = useState([]);

  function addBlock(type) {
    setBlocks(prev => [
      ...prev,
      { id: Date.now(), type, content: "" }
    ]);
  }

  function updateBlock(id, value) {
    setBlocks(prev =>
      prev.map(b => b.id === id ? { ...b, content: value } : b)
    );
  }

  function removeBlock(id) {
    setBlocks(prev => prev.filter(b => b.id !== id));
  }

  return (
    <>
      <AdminHeader />

      <div style={{ padding: 40, maxWidth: 900, margin: "0 auto" }}>

        <AdminPageHeader
          title="Editor Editorial"
          subtitle="Construye contenido con bloques."
          backTo="/admin/produccion/editorial"
        />

        {/* BOTONES */}
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>

          <button onClick={() => addBlock("text")}>+ Texto</button>
          <button onClick={() => addBlock("title")}>+ Título</button>
          <button onClick={() => addBlock("quote")}>+ Cita</button>

        </div>

        {/* BLOQUES */}
        {blocks.map(block => (
          <div key={block.id} style={card}>

            <div style={{ fontWeight: 600 }}>
              {block.type}
            </div>

            <textarea
              value={block.content}
              onChange={(e) => updateBlock(block.id, e.target.value)}
              style={textarea}
            />

            <button onClick={() => removeBlock(block.id)}>
              Eliminar
            </button>

          </div>
        ))}

      </div>
    </>
  );
}

/* estilos */
const card = {
  border: "1px solid #ddd",
  padding: 12,
  marginBottom: 12,
  borderRadius: 8
};

const textarea = {
  width: "100%",
  marginTop: 8,
  padding: 8
};